import React, { useEffect, useRef, useState } from 'react';

import LoadThemeComponent from '../../../../base/LoadThemeComponent';

import { formatBet } from '../../../../base/utils/soccerHelpers';

import LatestResultsApi from 'Api/SiteApi/LatestResultsApi';

interface Props {
    lotteryDrawId: number;
    isAllResults?: boolean;
}
export function BetsSection({ lotteryDrawId, isAllResults = false }: Props) {
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const rowMatchRef = useRef(null);
    const [sportBets, setSportBets] = useState([]);

    useEffect(() => {
        LatestResultsApi.getSportBetsResults(lotteryDrawId).then((data) => {
            setSportBets(data);
        });
    }, []);

    const renderMatch = (match, matchIndex) => (
        <p key={`match-${matchIndex}`} className="match-line mb-0 d-flex justify-content-between">
            <span className="fw-bold">
                {matchIndex + 1}. {match.competitors[0].name} - {match.competitors[1].name}
            </span>
            <span className="ml-auto">{formatBet(match.bet, matchIndex)}</span>
        </p>
    );

    const renderMatchForAllResults = (match, matchIndex) => (
        <p key={`match-${matchIndex}`} className="match-line mb-0 d-flex flex-column">
            <span className="fw-bold">
                {matchIndex + 1}. {match.competitors[0].name} - {match.competitors[1].name}
            </span>
            <span className="ml-auto">Result: {formatBet(match.bet, matchIndex)}</span>
        </p>
    );

    const handleScroll = (direction: 'left' | 'right') => {
        if (rowMatchRef.current) {
            const scrollAmount = rowMatchRef.current.offsetWidth;
            rowMatchRef.current.scrollLeft += direction === 'left' ? -scrollAmount : scrollAmount;
        }
    };

    const checkScroll = () => {
        if (rowMatchRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = rowMatchRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
        }
    };

    useEffect(() => {
        const ref = rowMatchRef.current;
        if (!ref) {
            return null;
        }

        checkScroll();
        ref.addEventListener('scroll', checkScroll);
        window.addEventListener('resize', checkScroll);

        return () => {
            ref.removeEventListener('scroll', checkScroll);
            window.removeEventListener('resize', checkScroll);
        };
    }, [sportBets]);

    const defaultView = () => (
        <>
            {isAllResults ? (
                <div className="row-wrapper d-flex flex-row w-100">
                    <div
                        className={`scroll-arrow scroll-arrow-left d-flex align-items-center position-relative ${
                            canScrollLeft ? 'show-overlay' : 'd-none'
                        }`}
                        onClick={() => handleScroll('left')}
                    >
                        <i className="fa fa-chevron-left" aria-hidden="true" />
                    </div>

                    <div className="d-flex row-match" key="match-line" ref={rowMatchRef}>
                        {sportBets[0].bets.map((match, matchIndex) => renderMatchForAllResults(match, matchIndex))}
                    </div>

                    <div
                        className={`scroll-arrow scroll-arrow-right d-flex align-items-center position-relative ${
                            canScrollRight ? 'show-overlay' : 'd-none'
                        }`}
                        onClick={() => handleScroll('right')}
                    >
                        <i className="fa fa-chevron-right" aria-hidden="true" />
                    </div>
                </div>
            ) : (
                <div className="row-wrapper d-flex flex-row">
                    <div className="row row-match" key="match-line">
                        {sportBets[0].bets.map((match, matchIndex) => renderMatch(match, matchIndex))}
                    </div>
                </div>
            )}
        </>
    );

    const baseView = () => (
        <div className="d-flex flex-row mt-5">
            <div className="row no-gutters">
                <div className="row row-match" key="match-line">
                    {sportBets[0].bets.map((match, matchIndex) => (
                        <p key={`match-${matchIndex}`} className="pr-5">
                            {matchIndex + 1}. {match.competitors[0].name} - {match.competitors[1].name}:{' '}
                            <strong>{formatBet(match.bet, matchIndex)}</strong>
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );

    function getDetails() {
        return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
    }

    return sportBets.length && sportBets[0].bets.length > 0 ? getDetails() : null;
}
